import React from 'react'
import BloomLogoSection from './BloomLogoSection'
import TimedCarousel from '../../TimedCarousel/TimedCarousel'

const BloomIntroSection = ({data}) => {
     
     
    return (
        <div className='bloom-intro-section'>
            <BloomLogoSection/>
            <div className='intro-grid'>
                <h4 className='bloom-intro'>
                    {data.v2IntroText?.v2IntroText}
                </h4>

                <TimedCarousel data={data.v2introHighlightedArticles}/>
            </div>

            <style jsx>{`   
                .bloom-intro-section {
                    padding: 200px 60px;
                    padding-top: 160px;
                }
                .bloom-intro {
                    line-height: 1.2;
                    font-size: 36px;
                    font-weight: 400;
                    color: #707070;
                }

                .intro-grid {
                    display: grid;
                    grid-template-columns: 550px 1fr;
                    grid-gap: 100px;
                }


                @media (max-width: 1024px) {
                    .intro-grid {
                        grid-template-columns: 1fr;
                        grid-gap: 0;
                    }
                }
                @media (max-width: 769px), (pointer: coarse) {
                    .intro-grid {
                        grid-template-columns: 1fr;
                        grid-gap: 0;
                    }
                    .bloom-intro {
                        font-size: 28px;
                    }

                    .bloom-intro-section {
                        padding: 120px 20px;
                    }
                }

            `}</style>
        </div>
    )
}

export default BloomIntroSection